import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createTextVNode as o, normalizeClass as s, normalizeStyle as c, onBeforeUnmount as l, onMounted as u, openBlock as d, ref as f, renderList as p, renderSlot as m, resolveDynamicComponent as h, toDisplayString as g, useTemplateRef as _, watch as v, withKeys as y, withModifiers as b } from "vue";
//#region src/components/cartesian/cartesian-layout.js
var x = 5, S = 7;
function C(e, t, n) {
	return typeof e == "function" ? e(t, n) : e;
}
function w(e, t, n, r) {
	let i = Number(t).toLocaleString();
	return typeof e == "function" ? String(e(t, n, r)) : typeof e == "string" ? e.includes("{value}") ? e.replaceAll("{value}", i) : `${i}${e}` : i;
}
function T(e, t, n) {
	return {
		category: t.category.datum,
		categoryIndex: t.category.index,
		categoryLabel: t.category.label,
		event: n,
		formattedValue: t.formattedValue,
		item: t.datum,
		pointIndex: t.index,
		series: e.datum,
		seriesId: e.id,
		seriesIndex: e.index,
		seriesLabel: e.label,
		value: t.value
	};
}
function E(e) {
	return String(e).toLowerCase().replace(/[^a-z0-9_-]+/g, "-").replace(/^-+|-+$/g, "");
}
function D(e, t, n) {
	let r = E(t), i = [
		"#8b8d98",
		"#009688",
		"#3e63dd",
		"#915930",
		"#ca244e",
		"#7c66dc"
	], a = `var(--cw-viz-${e}-series-${n}-color, ${i[n % i.length]})`;
	return r ? `var(--cw-viz-${e}-series-${r}-color, ${a})` : a;
}
function O(e, t) {
	let n = Math.max(Math.floor(t / S), 1);
	return e.length <= n ? e : n <= 1 ? "…" : `${e.slice(0, n - 1).trimEnd()}…`;
}
function k(e, t = void 0) {
	let n = Number(e);
	return Number.isFinite(n) ? n : t;
}
function A(e) {
	return Number.isFinite(e) ? Math.max(0, -Math.floor(Math.log10(Math.abs(e) || 1)) + 1) : 0;
}
function j(e, t) {
	return Number(e.toFixed(A(t)));
}
function M(e, t, n) {
	let r = e / t, i = 2 ** -52 * Math.max(Math.abs(r), 1) * 4;
	return j((n === "down" ? Math.floor(r + i) : Math.ceil(r - i)) * t, t);
}
function N(e, t = x) {
	let n = Math.max(Math.floor(t) - 1, 1), r = Math.abs(e) / n;
	if (!Number.isFinite(r) || r === 0) return 1;
	let i = 10 ** Math.floor(Math.log10(r)), a = r / i;
	return (a >= 7.5 ? 10 : a >= 3.5 ? 5 : a >= 1.5 ? 2 : 1) * i;
}
function P(e, t, n) {
	let r = k(t?.[0]), i = k(t?.[1]), a = e.map((e) => k(e)).filter((e) => e !== void 0);
	if (r !== void 0 && i !== void 0) return {
		domain: [Math.min(r, i), Math.max(r, i)],
		isExplicit: !0,
		values: a
	};
	let o = a.length ? Math.min(...a) : 0, s = a.length ? Math.max(...a) : 1;
	return o === 0 && s === 0 && (s = 1), n && (o = Math.min(o, 0), s = Math.max(s, 0)), {
		domain: [o, s],
		isExplicit: !1,
		values: a
	};
}
function F([e, t]) {
	return e === t ? Math.abs(e || 1) * .1 * 2 : t - e;
}
function I(e, t) {
	let n = typeof e == "function" ? e(t) : e;
	return typeof n == "number" && Number.isFinite(n) && n > 0 ? n : void 0;
}
function ee(e, t) {
	if (e.isExplicit) return {
		...e,
		step: t
	};
	let [n, r] = e.domain;
	if (n === r) {
		let e = Math.abs(n || 1) * .1;
		n -= e, r += e;
	}
	let i = M(n, t, "down"), a = M(r, t, "up");
	return i === a && (i = j(i - t, t), a = j(a + t, t)), {
		...e,
		domain: [i, a],
		isExplicit: !1,
		step: t
	};
}
function L(e, t, n, r) {
	let [i, a] = e.domain, o = t.filter((e) => e >= i && e <= a);
	if (o.length) return o;
	if (e.isExplicit && !r) {
		if (i === a) return [i];
		let e = Math.max(Math.floor(n) - 1, 1), t = (a - i) / e;
		return Array.from({ length: e + 1 }, (e, n) => j(i + t * n, t));
	}
	let s = [], c = e.step, l = M(i, c, "up");
	for (let e = l; e <= a + c / 2; e += c) s.push(j(e, c));
	return s;
}
function te({ count: e, end: t, paddingInner: n = 0, paddingOuter: r = 0, start: i }) {
	let a = Math.max(Math.floor(e), 0), o = Math.max(t - i, 0);
	if (!a) return {
		bandwidth: 0,
		positions: [],
		step: 0
	};
	let s = Math.min(Math.max(n, 0), 1), c = Math.max(r, 0), l = o / Math.max(a - s + c * 2, 1);
	return {
		bandwidth: l * (1 - s),
		positions: Array.from({ length: a }, (e, t) => i + l * (c + t)),
		step: l
	};
}
function R({ count: e, end: t, inset: n = 0, start: r }) {
	let i = Math.max(Math.floor(e), 0), a = Math.min(Math.max(n, 0), Math.max((t - r) / 2, 0)), o = r + a, s = t - a;
	if (!i) return {
		positions: [],
		step: 0
	};
	if (i === 1) return {
		positions: [(o + s) / 2],
		step: 0
	};
	let c = (s - o) / (i - 1);
	return {
		positions: Array.from({ length: i }, (e, t) => o + c * t),
		step: c
	};
}
function ne({ categoryCount: e, height: t, includeZero: n = !1, padding: r = {}, values: i = [], width: a, xInset: o, yDomain: s, yStepSize: c, yTickCount: l = x, yTicks: u }) {
	let d = Math.max(k(a, 0), 1), f = Math.max(k(t, 0), 1), p = {
		bottom: Math.max(f - k(r.bottom, 48), 1),
		left: Math.min(k(r.left, 52), d - 1),
		right: Math.max(d - k(r.right, 20), 1),
		top: Math.min(k(r.top, 24), f - 1)
	};
	p.right <= p.left && (p.right = p.left + 1), p.bottom <= p.top && (p.bottom = p.top + 1), p.height = p.bottom - p.top, p.width = p.right - p.left;
	let m = Math.max(Math.floor(k(l, x)), 2), h = P(i, s, n), g = Array.isArray(u) ? u.map((e) => k(e)).filter((e) => e !== void 0) : [], _ = g.length ? void 0 : I(c, {
		max: h.domain[1],
		min: h.domain[0],
		tickCount: m,
		values: [...h.values]
	}), v = ee(h, _ ?? N(F(h.domain), m)), [y, b] = v.domain, S = b - y || 1, C = (e) => p.bottom - (k(e, y) - y) / S * p.height, w = R({
		count: e,
		end: p.right,
		inset: k(o, Math.min(56, p.width * .05)),
		start: p.left
	});
	return {
		domain: v.domain,
		mapY: C,
		plot: p,
		xPositions: w.positions,
		xStep: w.step,
		yTicks: L(v, g, m, _ !== void 0).map((e) => ({
			value: e,
			y: C(e)
		}))
	};
}
//#endregion
//#region src/components/cartesian/bar-layout.js
var re = 72;
function ie({ height: e, radius: t, roundBottom: n, roundTop: r, width: i, y: a }) {
	if (e <= 0 || i <= 0) return "";
	let o = Math.min(Math.max(t, 0), i / 2, e / 2), s = r ? o : 0, c = n ? o : 0, l = -i / 2, u = i / 2, d = a + e;
	return [
		`M ${l + s} ${a}`,
		`H ${u - s}`,
		`Q ${u} ${a} ${u} ${a + s}`,
		`V ${d - c}`,
		`Q ${u} ${d} ${u - c} ${d}`,
		`H ${l + c}`,
		`Q ${l} ${d} ${l} ${d - c}`,
		`V ${a + s}`,
		`Q ${l} ${a} ${l + s} ${a}`,
		"Z"
	].join(" ");
}
function ae(e, t) {
	return Array.from({ length: t }, (t, n) => {
		let r = 0, i = 0;
		return e.forEach((e) => {
			let t = e[n];
			t !== void 0 && (t < 0 ? r += t : i += t);
		}), [r, i];
	}).flat();
}
function oe(e, t) {
	return Array.from({ length: t }, (t, n) => {
		let r = -1, i = -1;
		return e.forEach((e, t) => {
			let a = e[n];
			a !== void 0 && a !== 0 && (a < 0 ? r = t : i = t);
		}), {
			negative: r,
			positive: i
		};
	});
}
function z({ barGap: e, barRadius: t, categoryLabel: n, data: r, formatValue: i, height: a, maxBarWidth: o, pointDescription: s, pointValue: c, seriesColor: l, seriesId: u, seriesLabel: d, seriesValueColor: f, seriesValues: p, stacked: m, timeseries: h, width: g, yDomain: _, yStepSize: v, yTickCount: y, yTicks: b }) {
	let x = Array.isArray(r?.categories) ? r.categories : [], S = Array.isArray(r?.series) ? r.series : [];
	if (!x.length || !S.length) return {
		categories: [],
		domain: [0, 1],
		error: "",
		plot: {},
		series: [],
		yTicks: [],
		zeroY: 0
	};
	let T = x.map((e, t) => ({
		datum: e,
		index: t,
		label: String(n(e, t) ?? t + 1)
	})), E = S.map((e, t) => {
		let n = u(e, t) ?? t, r = C(p, e, t);
		return {
			color: C(l, e, t) || D("bar", n, t),
			datum: e,
			id: n,
			index: t,
			label: String(d(e, t) ?? n),
			rawPoints: Array.isArray(r) ? r : [],
			valueColor: C(f, e, t) || "var(--cw-viz-bar-value-color, #60646c)"
		};
	}), A = E.map((e) => T.map((t, n) => {
		let r = e.rawPoints[n];
		return k(c(r, n, e.datum));
	})), j = A.flatMap((e) => e.filter((e) => e !== void 0)), M = m ? ae(A, T.length) : j, N = ne({
		categoryCount: T.length,
		height: a,
		includeZero: !0,
		padding: {
			bottom: 52,
			left: 52,
			right: 20,
			top: 28
		},
		values: M,
		width: g,
		yDomain: _,
		yStepSize: v,
		yTickCount: y,
		yTicks: b
	}), P = te({
		count: T.length,
		end: N.plot.right,
		paddingInner: .28,
		paddingOuter: .14,
		start: N.plot.left
	}), F = Math.max(k(o, 48), 1), I = Math.max(k(e, 6), 0), ee = Math.max(k(t, 4), 0), L = oe(A, T.length), R = T.map(() => ({
		negative: 0,
		positive: 0
	}));
	T.forEach((e, t) => {
		let n = Math.max(Math.ceil(re / Math.max(P.step, 1)), 1);
		e.bandwidth = P.bandwidth, e.x = P.positions[t] + P.bandwidth / 2, e.displayLabel = O(e.label, Math.max((P.step || N.plot.width) * (h ? n : 1), 1) - 12);
		let r = T.length - 1;
		e.showLabel = !h || t === 0 || t === r || t % n === 0 && r - t >= n;
	});
	let z = E.length, B = Math.min(I, P.bandwidth / Math.max(z * 2, 1)), V = Math.min(F, Math.max((P.bandwidth - B * (z - 1)) / z, 1)), H = V * z + B * (z - 1), U = Math.min(P.bandwidth, F);
	return E.forEach((e) => {
		e.points = T.map((t, n) => {
			let r = e.rawPoints[n], a = A[e.index][n];
			if (a === void 0) return null;
			let o = typeof s == "function" ? s(r, n, e.datum) : void 0, c = o == null || o === "" ? void 0 : String(o), l = 0, u = a, d = t.x - H / 2 + V / 2 + e.index * (V + B), f = V;
			if (m) {
				let e = a < 0 ? "negative" : "positive";
				l = R[n][e], u = l + a, R[n][e] = u, d = t.x, f = U;
			}
			let p = N.mapY(l), h = N.mapY(u), g = Math.min(p, h), _ = Math.abs(h - p), v = a < 0 ? g + _ : g, y = !m || (a < 0 ? L[n].negative === e.index : L[n].positive === e.index), b = m && _ >= 24;
			return {
				anchorY: v,
				category: t,
				centerX: d,
				datum: r,
				description: c,
				endValue: u,
				formattedValue: w(i, a, r, e.datum),
				height: _,
				index: n,
				labelInside: b,
				labelY: b ? g + _ / 2 - v : a < 0 ? 14 : -10,
				path: ie({
					height: _,
					radius: ee,
					roundBottom: a < 0 && y,
					roundTop: a >= 0 && y,
					width: f,
					y: g - v
				}),
				startValue: l,
				value: a,
				width: f
			};
		});
	}), {
		categories: T,
		domain: N.domain,
		error: j.length ? "" : "Bar chart data must include at least one numeric value.",
		plot: N.plot,
		series: E,
		yTicks: N.yTicks.map((e) => ({
			formattedValue: w(i, e.value),
			value: e.value,
			y: e.y
		})),
		zeroY: N.mapY(0)
	};
}
//#endregion
//#region \0plugin-vue:export-helper
var B = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, V = {
	ref: "chart-root",
	class: "cw-viz-bar"
}, H = ["viewBox", "aria-label"], U = {
	key: 0,
	class: "cw-viz-bar__empty",
	x: "50%",
	y: "50%",
	"text-anchor": "middle"
}, se = { key: 1 }, ce = {
	class: "cw-viz-bar__axes",
	"data-viz-layer": "axes"
}, le = [
	"x1",
	"x2",
	"y1",
	"y2"
], ue = [
	"x1",
	"x2",
	"y1",
	"y2"
], de = [
	"x1",
	"x2",
	"y1",
	"y2"
], fe = ["transform"], pe = ["x1", "x2"], me = ["x"], he = ["transform"], ge = {
	class: "cw-viz-bar__axis-label cw-viz-bar__axis-label--x",
	x: "0",
	y: "30",
	"text-anchor": "middle"
}, _e = {
	class: "cw-viz-bar__series-layer",
	"data-viz-layer": "series"
}, ve = ["data-series-id"], ye = [
	"transform",
	"data-point-index",
	"tabindex",
	"role",
	"aria-label",
	"onClick",
	"onKeydown",
	"onPointerenter",
	"onFocus"
], be = ["d", "fill"], xe = ["y", "fill"], Se = { class: "cw-viz-bar__tooltip-title" }, Ce = { class: "cw-viz-bar__tooltip-list" }, we = { class: "cw-viz-bar__tooltip-label" }, Te = { class: "cw-viz-bar__tooltip-value" }, Ee = {
	key: 0,
	class: "cw-viz-bar__tooltip-description"
}, De = /*#__PURE__*/ B(/* @__PURE__ */ Object.assign({ name: "BarChart" }, {
	__name: "BarChart",
	props: {
		ariaLabel: {
			type: String,
			default: "Bar chart"
		},
		barGap: {
			type: Number,
			default: 6
		},
		barRadius: {
			type: Number,
			default: 4
		},
		categoryLabel: {
			type: Function,
			default: (e) => e?.label ?? e
		},
		data: {
			type: Object,
			required: !0
		},
		formatValue: {
			type: [Function, String],
			default: () => (e) => Number(e).toLocaleString()
		},
		height: {
			type: Number,
			default: 360
		},
		maxBarWidth: {
			type: Number,
			default: 48
		},
		onItemClick: {
			type: Function,
			default: void 0
		},
		pointDescription: {
			type: Function,
			default: (e) => e?.description
		},
		pointValue: {
			type: Function,
			default: (e) => typeof e == "number" ? e : e?.value ?? e?.y
		},
		seriesColor: {
			type: [Function, String],
			default: () => (e) => e.color
		},
		seriesId: {
			type: Function,
			default: (e, t) => e.id ?? t
		},
		seriesLabel: {
			type: Function,
			default: (e, t) => e.label ?? e.id ?? `Series ${t + 1}`
		},
		seriesValueColor: {
			type: [Function, String],
			default: () => (e) => e.valueColor ?? e.labelColor
		},
		seriesValues: {
			type: Function,
			default: (e) => e.data ?? e.values ?? []
		},
		showTooltip: {
			type: Boolean,
			default: !0
		},
		showValues: {
			type: Boolean,
			default: !1
		},
		stacked: {
			type: Boolean,
			default: !1
		},
		timeseries: {
			type: Boolean,
			default: !1
		},
		width: {
			type: Number,
			default: 960
		},
		yDomain: {
			type: Array,
			default: void 0
		},
		yStepSize: {
			type: [Number, Function],
			default: void 0,
			validator: (e) => typeof e == "function" || Number.isFinite(e) && e > 0
		},
		yTickCount: {
			type: Number,
			default: 5
		},
		yTicks: {
			type: Array,
			default: void 0
		}
	},
	setup(n) {
		let o = n, m = _("chart-root"), h = f(0), v = f(null), y, b, x = t(() => Math.max(Math.round(h.value || o.width), 280)), S = t(() => z({
			barGap: o.barGap,
			barRadius: o.barRadius,
			categoryLabel: o.categoryLabel,
			data: o.data,
			formatValue: o.formatValue,
			height: o.height,
			maxBarWidth: o.maxBarWidth,
			pointDescription: o.pointDescription,
			pointValue: o.pointValue,
			seriesColor: o.seriesColor,
			seriesId: o.seriesId,
			seriesLabel: o.seriesLabel,
			seriesValueColor: o.seriesValueColor,
			seriesValues: o.seriesValues,
			stacked: o.stacked,
			timeseries: o.timeseries,
			width: x.value,
			yDomain: o.yDomain,
			yStepSize: o.yStepSize,
			yTickCount: o.yTickCount,
			yTicks: o.yTicks
		})), C = t(() => {
			if (S.value.error) return S.value.error;
			let e = o.stacked ? "stacked" : "grouped";
			return `${S.value.series.length} ${e} series across ${S.value.categories.length} categories.`;
		}), w = t(() => {
			if (!o.showTooltip || !v.value) return null;
			let e = S.value.series[v.value.seriesIndex]?.points[v.value.pointIndex];
			return e ? {
				category: e.category.label,
				horizontalPosition: e.centerX < x.value * .25 ? "start" : e.centerX > x.value * .75 ? "end" : "center",
				rows: S.value.series.flatMap((e) => {
					let t = e.points[v.value.pointIndex];
					return t ? [{
						color: e.color,
						description: t.description,
						formattedValue: t.formattedValue,
						id: e.id,
						isActive: e.index === v.value.seriesIndex,
						label: e.label
					}] : [];
				}),
				showBelow: e.anchorY < o.height * .3,
				x: v.value.x,
				y: v.value.y
			} : null;
		});
		function E(e) {
			Number.isFinite(e) && e > 0 && (h.value = e, v.value = null);
		}
		function D(e, t, n) {
			if (!o.showTooltip) return;
			let r = m.value?.getBoundingClientRect(), i = n.currentTarget?.getScreenCTM?.(), a = S.value.series[e]?.points[t];
			!r || !a || (v.value = {
				pointIndex: t,
				seriesIndex: e,
				x: i ? i.e - r.left : a.centerX / x.value * r.width,
				y: i ? i.f - r.top : a.anchorY / o.height * r.height
			});
		}
		function O() {
			v.value = null;
		}
		function k(e, t, n) {
			if (!o.onItemClick) return;
			let r = S.value.series[e], i = r?.points[t];
			!r || !i || o.onItemClick(T(r, i, n));
		}
		function A(e, t, n) {
			!o.onItemClick || !["Enter", " "].includes(n.key) || (n.preventDefault(), k(e, t, n));
		}
		function j(e) {
			if (typeof requestAnimationFrame > "u") {
				E(e);
				return;
			}
			y && cancelAnimationFrame(y), y = requestAnimationFrame(() => {
				y = void 0, E(e);
			});
		}
		return u(() => {
			E(m.value?.getBoundingClientRect().width), !(typeof ResizeObserver > "u" || !m.value) && (b = new ResizeObserver((e) => {
				j(e[0]?.contentRect.width);
			}), b.observe(m.value));
		}), l(() => {
			b?.disconnect(), y && cancelAnimationFrame(y);
		}), (t, o) => (d(), i("div", V, [(d(), i("svg", {
			class: "cw-viz-bar__svg",
			viewBox: `0 0 ${x.value} ${n.height}`,
			role: "img",
			"aria-label": n.ariaLabel,
			preserveAspectRatio: "xMidYMid meet"
		}, [a("desc", null, g(C.value), 1), S.value.error || !S.value.series.length ? (d(), i("text", U, g(S.value.error || "No bar data to display."), 1)) : (d(), i("g", se, [a("g", ce, [
			a("line", {
				class: "cw-viz-bar__axis",
				x1: S.value.plot.left,
				x2: S.value.plot.left,
				y1: S.value.plot.top,
				y2: S.value.plot.bottom
			}, null, 8, le),
			a("line", {
				class: "cw-viz-bar__axis",
				x1: S.value.plot.left,
				x2: S.value.plot.right,
				y1: S.value.plot.bottom,
				y2: S.value.plot.bottom
			}, null, 8, ue),
			Math.abs(S.value.zeroY - S.value.plot.bottom) > .5 ? (d(), i("line", {
				key: 0,
				class: "cw-viz-bar__zero-line",
				x1: S.value.plot.left,
				x2: S.value.plot.right,
				y1: S.value.zeroY,
				y2: S.value.zeroY
			}, null, 8, de)) : r("", !0),
			(d(!0), i(e, null, p(S.value.yTicks, (e) => (d(), i("g", {
				key: e.value,
				class: "cw-viz-bar__y-tick",
				transform: `translate(0 ${e.y})`
			}, [a("line", {
				class: "cw-viz-bar__tick-mark",
				x1: S.value.plot.left - 9,
				x2: S.value.plot.left,
				y1: "0",
				y2: "0"
			}, null, 8, pe), a("text", {
				class: "cw-viz-bar__axis-label cw-viz-bar__axis-label--y",
				x: S.value.plot.left - 14,
				y: "0",
				"dominant-baseline": "central",
				"text-anchor": "end"
			}, g(e.formattedValue), 9, me)], 8, fe))), 128)),
			(d(!0), i(e, null, p(S.value.categories.filter((e) => e.showLabel), (e) => (d(), i("g", {
				key: e.index,
				class: "cw-viz-bar__x-tick",
				transform: `translate(${e.x} ${S.value.plot.bottom})`
			}, [o[0] ||= a("line", {
				class: "cw-viz-bar__tick-mark",
				x1: "0",
				x2: "0",
				y1: "0",
				y2: "10"
			}, null, -1), a("text", ge, g(e.displayLabel), 1)], 8, he))), 128))
		]), a("g", _e, [(d(!0), i(e, null, p(S.value.series, (t) => (d(), i("g", {
			key: t.id,
			class: "cw-viz-bar__series",
			"data-series-id": t.id
		}, [(d(!0), i(e, null, p(t.points.filter(Boolean), (e) => (d(), i("g", {
			key: e.index,
			class: s(["cw-viz-bar__bar-group", { "cw-viz-bar__bar-group--clickable": n.onItemClick }]),
			transform: `translate(${e.centerX} ${e.anchorY})`,
			"data-point-index": e.index,
			tabindex: n.showTooltip || n.onItemClick ? 0 : void 0,
			role: n.onItemClick ? "button" : void 0,
			"aria-label": `${t.label}, ${e.category.label}: ${e.formattedValue}${e.description ? `. ${e.description}` : ""}`,
			onClick: (n) => k(t.index, e.index, n),
			onKeydown: (n) => A(t.index, e.index, n),
			onPointerenter: (n) => D(t.index, e.index, n),
			onPointerleave: O,
			onFocus: (n) => D(t.index, e.index, n),
			onBlur: O
		}, [a("path", {
			class: "cw-viz-bar__bar",
			d: e.path,
			fill: t.color
		}, null, 8, be), n.showValues && e.height > 0 ? (d(), i("text", {
			key: 0,
			class: s(["cw-viz-bar__value", { "cw-viz-bar__value--inside": e.labelInside }]),
			x: "0",
			y: e.labelY,
			fill: e.labelInside ? void 0 : t.valueColor,
			"dominant-baseline": "central",
			"text-anchor": "middle"
		}, g(e.formattedValue), 11, xe)) : r("", !0)], 42, ye))), 128))], 8, ve))), 128))])]))], 8, H)), w.value ? (d(), i("div", {
			key: 0,
			class: s(["cw-viz-bar__tooltip", [`cw-viz-bar__tooltip--${w.value.horizontalPosition}`, { "cw-viz-bar__tooltip--below": w.value.showBelow }]]),
			style: c({
				left: `${w.value.x}px`,
				top: `${w.value.y}px`
			}),
			role: "tooltip"
		}, [a("p", Se, g(w.value.category), 1), a("div", Ce, [(d(!0), i(e, null, p(w.value.rows, (e) => (d(), i("div", {
			key: e.id,
			class: s(["cw-viz-bar__tooltip-row", { "cw-viz-bar__tooltip-row--active": e.isActive }])
		}, [
			a("span", {
				class: "cw-viz-bar__tooltip-swatch",
				style: c({ backgroundColor: e.color })
			}, null, 4),
			a("span", we, g(e.label), 1),
			a("strong", Te, g(e.formattedValue), 1),
			e.description ? (d(), i("span", Ee, g(e.description), 1)) : r("", !0)
		], 2))), 128))])], 6)) : r("", !0)], 512));
	}
}), [["__scopeId", "data-v-827f3695"]]);
//#endregion
//#region src/components/aggregate/aggregate-layout.js
function Oe(e) {
	return Number(e.toFixed(2));
}
function ke({ color: e, datum: t, description: n, formatPercentage: r, formatValue: i, id: a, index: o, isRemainder: s, label: c, percentage: l, showRawValue: u, sourceIndex: d, value: f }) {
	let p = w(r, Oe(l), t), m = w(i, f, t);
	return {
		color: e,
		datum: t,
		description: String(n ?? ""),
		formattedPercentage: p,
		formattedValue: m,
		id: String(a),
		index: o,
		isRemainder: s,
		key: `${String(a)}:${o}`,
		label: String(c ?? ""),
		percentage: l,
		sourceIndex: d,
		tooltipValue: u ? `${m} · ${p}` : p,
		value: f
	};
}
function Ae({ chartName: e = "Aggregate chart", colorNamespace: t = "aggregate", data: n, formatPercentage: r, formatValue: i, remainderColor: a, remainderLabel: o, segmentColor: s, segmentId: c, segmentLabel: l, segmentValue: u }) {
	let d = Array.isArray(n?.segments) ? n.segments : [], f = d.flatMap((e, n) => {
		let r = k(C(u, e, n));
		if (r === void 0 || r < 0) return [];
		let i = C(c, e, n) ?? n, a = C(l, e, n) ?? `Segment ${n + 1}`;
		return [{
			color: C(s, e, n) || D(t, i, n),
			datum: e,
			description: e?.description,
			id: i,
			label: a,
			sourceIndex: n,
			value: r
		}];
	}), p = f.reduce((e, t) => e + t.value, 0), m = n?.total !== void 0 && n?.total !== null, h = m ? k(n.total) : void 0;
	if (!Number.isFinite(p)) return {
		error: `${e} segment total must be a finite number.`,
		segments: []
	};
	if (m && (h === void 0 || h <= 0)) return {
		error: `${e} total must be a positive number.`,
		segments: []
	};
	if (!m && p <= 0) return {
		error: `${e} data requires at least one positive segment value.`,
		segments: []
	};
	let g = m ? h : p, _ = Math.max(g, 1) * 2 ** -52 * 16;
	if (p - g > _) return {
		error: `${e} segment values cannot exceed the total.`,
		segments: [],
		total: g,
		used: p
	};
	let v = f.map((e, t) => {
		let n = e.value / g * 100, a = m || e.value !== Oe(n);
		return ke({
			...e,
			formatPercentage: r,
			formatValue: i,
			index: t,
			isRemainder: !1,
			percentage: n,
			showRawValue: a
		});
	}), y = Math.max(g - p, 0);
	return m && y > _ && v.push(ke({
		color: a,
		datum: null,
		description: "",
		formatPercentage: r,
		formatValue: i,
		id: "__remainder",
		index: v.length,
		isRemainder: !0,
		label: o,
		percentage: y / g * 100,
		showRawValue: !0,
		sourceIndex: d.length,
		value: y
	})), {
		error: "",
		hasExplicitTotal: m,
		remainder: y,
		segments: v,
		total: g,
		used: p
	};
}
//#endregion
//#region src/components/donut/donut-layout.js
var W = 360, je = 200, Me = 24, Ne = 3, Pe = 2;
function Fe(e, t) {
	let n = Number(e);
	return Number.isFinite(n) && n > 0 ? n : t;
}
function Ie(e, t) {
	let n = Number(e);
	return Number.isFinite(n) && n >= 0 ? n : t;
}
function Le(e) {
	return e * 180 / Math.PI;
}
function Re(e, t) {
	return Le(Math.asin(Math.min(t / e, 1)));
}
function G(e, t, n) {
	let r = n * Math.PI / 180;
	return {
		x: e + t * Math.cos(r),
		y: e + t * Math.sin(r)
	};
}
function K(e) {
	return Number(e.toFixed(4));
}
function ze(e, t, n, r, i, a, o) {
	let s = G(e, n, r), c = G(e, n, i), l = G(e, t, o), u = G(e, t, a), d = i - r, f = o - a;
	if (d >= 359.999) {
		let i = G(e, n, r + W / 2), o = G(e, t, a + W / 2);
		return [
			`M ${K(s.x)} ${K(s.y)}`,
			`A ${K(n)} ${K(n)} 0 1 1 ${K(i.x)} ${K(i.y)}`,
			`A ${K(n)} ${K(n)} 0 1 1 ${K(c.x)} ${K(c.y)}`,
			`L ${K(l.x)} ${K(l.y)}`,
			`A ${K(t)} ${K(t)} 0 1 0 ${K(o.x)} ${K(o.y)}`,
			`A ${K(t)} ${K(t)} 0 1 0 ${K(u.x)} ${K(u.y)}`,
			"Z"
		].join(" ");
	}
	return [
		`M ${K(s.x)} ${K(s.y)}`,
		`A ${K(n)} ${K(n)} 0 ${+(d > 180)} 1 ${K(c.x)} ${K(c.y)}`,
		`L ${K(l.x)} ${K(l.y)}`,
		`A ${K(t)} ${K(t)} 0 ${+(f > 180)} 0 ${K(u.x)} ${K(u.y)}`,
		"Z"
	].join(" ");
}
function Be({ cornerRadius: e = Pe, data: t, diameter: n = je, formatPercentage: r, formatValue: i, remainderColor: a, remainderLabel: o, segmentColor: s, segmentGap: c = Ne, segmentId: l, segmentLabel: u, segmentValue: d, thickness: f = Me }) {
	let p = Fe(n, je), m = Math.min(Fe(f, Me), p / 2), h = Ie(c, Ne), g = Math.min(Ie(e, Pe), m / 4), _ = p / 2, v = _ - g, y = Math.max(_ - m + g, .001), b = (v + y) / 2, x = Ae({
		chartName: "Donut chart",
		colorNamespace: "donut",
		data: t,
		formatPercentage: r,
		formatValue: i,
		remainderColor: a,
		remainderLabel: o,
		segmentColor: s,
		segmentId: l,
		segmentLabel: u,
		segmentValue: d
	}), S = x.segments.filter((e) => e.percentage > 0).length, C = -90, w = x.segments.map((e) => {
		let t = e.percentage / 100 * W, n = C, r = n + t / 2;
		if (C += t, e.percentage <= 0) return {
			...e,
			geometry: null,
			path: "",
			shape: "none",
			tooltipX: _,
			tooltipY: _
		};
		let i = G(_, b, r), a = S === 1 ? 0 : h / 2 + g, o = Math.max(y * Math.sin(Math.min(t, 180) * Math.PI / 360) - .001, 0), s = Math.min(a, o), c = Re(v, s), l = Re(y, s), u = n + c, d = n + t - c, f = n + l, p = n + t - l;
		return {
			...e,
			geometry: {
				halfCut: s,
				innerEndAngle: p,
				innerStartAngle: f,
				outerEndAngle: d,
				outerStartAngle: u
			},
			path: ze(_, y, v, u, d, f, p),
			shape: "path",
			tooltipX: i.x,
			tooltipY: i.y
		};
	});
	return {
		...x,
		center: _,
		cornerRadius: g,
		diameter: p,
		innerRadius: y,
		outerRadius: v,
		radius: b,
		segmentGap: h,
		segments: w,
		thickness: m
	};
}
//#endregion
//#region src/components/donut/DonutChart.vue
var Ve = ["aria-label"], He = { class: "cw-viz-donut__description" }, Ue = {
	key: 0,
	class: "cw-viz-donut__empty"
}, We = { class: "cw-viz-donut__visual" }, Ge = ["viewBox"], Ke = [
	"data-segment-id",
	"role",
	"tabindex",
	"aria-label",
	"onPointerenter",
	"onFocus",
	"onKeydown",
	"onClick"
], qe = ["d"], Je = [
	"d",
	"fill",
	"stroke"
], Ye = {
	key: 0,
	class: "cw-viz-donut__center"
}, Xe = { class: "cw-viz-donut__tooltip-main" }, Ze = {
	key: 0,
	class: "cw-viz-donut__tooltip-description"
}, Qe = {
	key: 1,
	class: "cw-viz-donut__legend"
}, $e = /*#__PURE__*/ B(/* @__PURE__ */ Object.assign({ name: "DonutChart" }, {
	__name: "DonutChart",
	props: {
		ariaLabel: {
			type: String,
			default: "Donut chart"
		},
		cornerRadius: {
			type: Number,
			default: 2
		},
		data: {
			type: Object,
			required: !0
		},
		diameter: {
			type: Number,
			default: 200
		},
		formatPercentage: {
			type: [Function, String],
			default: "%"
		},
		formatValue: {
			type: [Function, String],
			default: () => (e) => Number(e).toLocaleString()
		},
		onItemClick: {
			type: Function,
			default: void 0
		},
		remainderColor: {
			type: String,
			default: "var(--cw-viz-donut-remainder-color, #f0f0f3)"
		},
		remainderLabel: {
			type: String,
			default: "Unused"
		},
		segmentColor: {
			type: [Function, String],
			default: () => (e) => e?.color
		},
		segmentGap: {
			type: Number,
			default: 3
		},
		segmentId: {
			type: Function,
			default: (e, t) => e?.id ?? t
		},
		segmentLabel: {
			type: Function,
			default: (e, t) => e?.label ?? e?.id ?? `Segment ${t + 1}`
		},
		segmentValue: {
			type: Function,
			default: (e) => typeof e == "number" ? e : e?.value ?? e?.count
		},
		showLegend: {
			type: Boolean,
			default: !0
		},
		showTooltip: {
			type: Boolean,
			default: !0
		},
		thickness: {
			type: Number,
			default: 24
		}
	},
	setup(n) {
		let o = n, l = _("chart-root"), u = _("donut-svg"), h = f(null), x = t(() => Be({
			cornerRadius: o.cornerRadius,
			data: o.data,
			diameter: o.diameter,
			formatPercentage: o.formatPercentage,
			formatValue: o.formatValue,
			remainderColor: o.remainderColor,
			remainderLabel: o.remainderLabel,
			segmentColor: o.segmentColor,
			segmentGap: o.segmentGap,
			segmentId: o.segmentId,
			segmentLabel: o.segmentLabel,
			segmentValue: o.segmentValue,
			thickness: o.thickness
		})), S = t(() => ({
			"--cw-viz-donut-corner-stroke-width": `${x.value.cornerRadius * 2}px`,
			"--cw-viz-donut-diameter": `${x.value.diameter}px`,
			"--cw-viz-donut-focus-stroke-width": `${x.value.cornerRadius * 2 + 4}px`
		})), C = t(() => x.value.segments.filter((e) => e.shape !== "none")), w = t(() => o.showTooltip ? h.value : null), T = t(() => x.value.error ? x.value.error : x.value.segments.map((e) => `${e.label}: ${e.tooltipValue}${e.description ? `. ${e.description}` : ""}`).join(", "));
		function E(e) {
			if (!o.showTooltip) return;
			let t = l.value?.getBoundingClientRect(), n = u.value?.getBoundingClientRect();
			if (!t || !n) return;
			let r = n.left - t.left + e.tooltipX / x.value.diameter * n.width, i = n.top - t.top + e.tooltipY / x.value.diameter * n.height;
			h.value = {
				horizontalPosition: r < t.width * .25 ? "start" : r > t.width * .75 ? "end" : "center",
				description: e.description,
				label: e.label,
				segmentIndex: e.index,
				value: e.tooltipValue,
				x: r,
				y: i
			};
		}
		function D() {
			h.value = null;
		}
		v(x, D);
		function O(e, t) {
			o.onItemClick && o.onItemClick({
				description: e.description,
				event: t,
				formattedPercentage: e.formattedPercentage,
				formattedValue: e.formattedValue,
				id: e.id,
				index: e.index,
				isRemainder: e.isRemainder,
				item: e.datum,
				itemType: e.isRemainder ? "remainder" : "segment",
				label: e.label,
				percentage: e.percentage,
				value: e.value
			});
		}
		return (t, o) => (d(), i("div", {
			ref: "chart-root",
			class: "cw-viz-donut",
			style: c(S.value),
			role: "group",
			"aria-label": n.ariaLabel
		}, [a("p", He, g(T.value), 1), x.value.error ? (d(), i("p", Ue, g(x.value.error), 1)) : (d(), i(e, { key: 1 }, [
			a("div", We, [(d(), i("svg", {
				ref: "donut-svg",
				class: "cw-viz-donut__svg",
				viewBox: `0 0 ${x.value.diameter} ${x.value.diameter}`
			}, [(d(!0), i(e, null, p(C.value, (e) => (d(), i("g", {
				key: e.key,
				class: s(["cw-viz-donut__segment-group", {
					"cw-viz-donut__segment-group--interactive": n.showTooltip || n.onItemClick,
					"cw-viz-donut__segment-group--remainder": e.isRemainder
				}]),
				"data-segment-id": e.id,
				role: n.showTooltip || n.onItemClick ? "button" : void 0,
				tabindex: n.showTooltip || n.onItemClick ? 0 : void 0,
				"aria-label": `${e.label}: ${e.tooltipValue}${e.description ? `. ${e.description}` : ""}`,
				onPointerenter: (t) => E(e),
				onPointerleave: D,
				onFocus: (t) => E(e),
				onBlur: D,
				onKeydown: [
					y(D, ["esc"]),
					y(b((t) => O(e, t), ["prevent"]), ["enter"]),
					y(b((t) => O(e, t), ["prevent"]), ["space"])
				],
				onClick: (t) => O(e, t)
			}, [a("path", {
				class: "cw-viz-donut__focus-ring",
				d: e.path,
				fill: "none"
			}, null, 8, qe), a("path", {
				class: "cw-viz-donut__segment",
				d: e.path,
				fill: e.color,
				stroke: e.color
			}, null, 8, Je)], 42, Ke))), 128))], 8, Ge)), t.$slots.center ? (d(), i("div", Ye, [m(t.$slots, "center", {
				hasExplicitTotal: x.value.hasExplicitTotal,
				remainder: x.value.remainder,
				total: x.value.total,
				used: x.value.used
			}, void 0, !0)])) : r("", !0)]),
			w.value ? (d(), i("div", {
				key: 0,
				class: s(["cw-viz-donut__tooltip", `cw-viz-donut__tooltip--${w.value.horizontalPosition}`]),
				style: c({
					left: `${w.value.x}px`,
					top: `${w.value.y}px`
				}),
				role: "tooltip"
			}, [a("div", Xe, [a("span", null, g(w.value.label), 1), a("strong", null, g(w.value.value), 1)]), w.value.description ? (d(), i("span", Ze, g(w.value.description), 1)) : r("", !0)], 6)) : r("", !0),
			n.showLegend ? (d(), i("ul", Qe, [(d(!0), i(e, null, p(x.value.segments, (e) => (d(), i("li", {
				key: e.key,
				class: s({ "cw-viz-donut__legend-item--remainder": e.isRemainder })
			}, [m(t.$slots, "legend-item", {
				color: e.color,
				description: e.description,
				formattedPercentage: e.formattedPercentage,
				formattedValue: e.formattedValue,
				id: e.id,
				index: e.index,
				isRemainder: e.isRemainder,
				item: e.datum,
				label: e.label,
				percentage: e.percentage,
				value: e.value
			}, () => [
				a("span", {
					class: s(["cw-viz-donut__swatch", { "cw-viz-donut__swatch--remainder": e.isRemainder }]),
					style: c({ "--cw-viz-donut-segment-color": e.color }),
					"aria-hidden": "true"
				}, null, 6),
				a("span", null, g(e.label), 1),
				a("strong", null, g(e.formattedPercentage), 1)
			], !0)], 2))), 128))])) : r("", !0)
		], 64))], 12, Ve));
	}
}), [["__scopeId", "data-v-ea9b2194"]]);
//#endregion
//#region src/components/heatmap/heatmap-layout.js
function q(e, t, ...n) {
	return typeof e == "function" ? e(...n) : e ?? t;
}
function et(e, t, n) {
	let r = k(n?.[0]), i = k(n?.[1]);
	return r !== void 0 && i !== void 0 ? [Math.min(r, i), Math.max(r, i)] : e === void 0 || t === void 0 ? [0, 1] : [e, t];
}
function tt(e) {
	return Array.isArray(e) ? [...new Set(e.map(k).filter((e) => e >= 0 && e <= 1))].toSorted((e, t) => e - t) : [];
}
function nt(e, t) {
	let n = (e.length - 1) * t, r = Math.floor(n), i = n - r, a = e[r], o = e[r + 1];
	return o === void 0 ? a : a + i * (o - a);
}
function rt(e, t) {
	if (!e.length || !t.length) return [];
	let n = e.toSorted((e, t) => e - t);
	return t.map((e) => nt(n, e));
}
function it(e, t, n, r) {
	if (e === void 0) return;
	if (r.length) {
		let t = r.findIndex((t) => e <= t), i = t === -1 ? r.length : t;
		return Math.min(i, n - 1);
	}
	let [i, a] = t;
	if (i === a) return n - 1;
	let o = Math.min(Math.max((e - i) / (a - i), 0), 1);
	return Math.min(Math.floor(o * n), n - 1);
}
function at(e) {
	return Math.max(Math.floor(k(e) ?? 5), 1);
}
function ot(e) {
	return e == null ? void 0 : k(e);
}
function st({ cellColor: e, cellValue: t, columnId: n, columnLabel: r, data: i, domain: a, excludeZeroFromQuantiles: o = !1, formatValue: s, levelCount: c, quantiles: l, rowDescription: u, rowId: d, rowLabel: f, rowValues: p }) {
	let m = Array.isArray(i?.columns) ? i.columns : [], h = Array.isArray(i?.rows) ? i.rows : [], g = at(c), _ = tt(l), v = m.map((e, t) => ({
		datum: e,
		id: String(q(n, e?.id ?? t, e, t)),
		index: t,
		label: String(q(r, e?.label ?? e, e, t) ?? "")
	})), y = h.map((e, t) => {
		let n = q(p, e?.data ?? e?.values ?? [], e, t);
		return {
			datum: e,
			description: String(q(u, e?.description ?? e?.sublabel ?? "", e, t) ?? ""),
			id: String(q(d, e?.id ?? t, e, t)),
			index: t,
			label: String(q(f, e?.label ?? e?.id ?? t, e, t) ?? ""),
			values: Array.isArray(n) ? n : []
		};
	}), b, x, S = [], C = y.map((n) => (n.cells = v.map((r) => {
		let i = n.values[r.index], a = ot(q(t, i?.value ?? i?.count ?? i, i, n.datum, r.datum)), c = q(e, typeof i == "object" ? i?.color : void 0, i, n.datum, r.datum);
		return a !== void 0 && (b = b === void 0 ? a : Math.min(b, a), x = x === void 0 ? a : Math.max(x, a), _.length && (!o || a !== 0) && S.push(a)), {
			color: c,
			column: r,
			datum: i,
			formattedValue: a === void 0 ? "" : w(s, a, i, n.datum),
			id: `${n.id}:${r.id}`,
			value: a
		};
	}), n)), T = et(b, x, a), E = rt(S, _);
	for (let e of C) for (let t of e.cells) t.level = it(t.value, T, g, E);
	return {
		columns: v,
		domain: T,
		error: !v.length || !C.length ? "Heatmap data requires at least one column and row." : "",
		levelCount: g,
		quantileThresholds: E,
		quantiles: _,
		rows: C
	};
}
//#endregion
//#region src/components/heatmap/HeatmapChart.vue
var ct = ["aria-label"], lt = { class: "cw-viz-heatmap__description" }, ut = {
	key: 0,
	class: "cw-viz-heatmap__empty"
}, dt = {
	key: 1,
	class: "cw-viz-heatmap__scroll"
}, ft = {
	class: "cw-viz-heatmap__row-label",
	role: "rowheader"
}, pt = { key: 0 }, mt = {
	key: 1,
	class: "cw-viz-heatmap__cell cw-viz-heatmap__cell--empty",
	role: "gridcell"
}, ht = {
	class: "cw-viz-heatmap__row cw-viz-heatmap__header-row",
	role: "row"
}, gt = { class: "cw-viz-heatmap__tooltip-title" }, _t = { key: 0 }, vt = { class: "cw-viz-heatmap__tooltip-row" }, yt = /*#__PURE__*/ B(/* @__PURE__ */ Object.assign({ name: "HeatmapChart" }, {
	__name: "HeatmapChart",
	props: {
		ariaLabel: {
			type: String,
			default: "Heatmap chart"
		},
		cellColor: {
			type: [Function, String],
			default: () => (e) => e?.color
		},
		cellHeight: {
			type: Number,
			default: 32
		},
		cellMinWidth: {
			type: Number,
			default: 28
		},
		cellValue: {
			type: Function,
			default: (e) => typeof e == "number" ? e : e?.value ?? e?.count
		},
		columnId: {
			type: Function,
			default: (e, t) => e?.id ?? t
		},
		columnLabel: {
			type: Function,
			default: (e) => e?.label ?? e
		},
		colors: {
			type: Array,
			default: void 0
		},
		data: {
			type: Object,
			required: !0
		},
		domain: {
			type: Array,
			default: void 0
		},
		formatValue: {
			type: [Function, String],
			default: () => (e) => Number(e).toLocaleString()
		},
		gap: {
			type: Number,
			default: 4
		},
		onItemClick: {
			type: Function,
			default: void 0
		},
		quantiles: {
			type: Array,
			default: void 0
		},
		rowDescription: {
			type: Function,
			default: (e) => e?.description ?? e?.sublabel ?? ""
		},
		rowId: {
			type: Function,
			default: (e, t) => e?.id ?? t
		},
		rowLabel: {
			type: Function,
			default: (e, t) => e?.label ?? e?.id ?? t
		},
		rowLabelWidth: {
			type: Number,
			default: 120
		},
		rowValues: {
			type: Function,
			default: (e) => e?.data ?? e?.values ?? []
		},
		showTooltip: {
			type: Boolean,
			default: !0
		},
		zeroColor: {
			type: String,
			default: void 0
		}
	},
	setup(l) {
		let u = [
			"var(--cw-viz-heatmap-level-0-color, #f8f8fa)",
			"var(--cw-viz-heatmap-level-1-color, #e2efff)",
			"var(--cw-viz-heatmap-level-2-color, #bdd9fb)",
			"var(--cw-viz-heatmap-level-3-color, #8ab6f0)",
			"var(--cw-viz-heatmap-level-4-color, #1c73dc)"
		], m = l, v = _("chart-root"), b = f(null), x = t(() => {
			let e = Array.isArray(m.colors) ? m.colors.filter((e) => typeof e == "string" && e.trim()) : [];
			return e.length ? e : u;
		}), S = t(() => typeof m.zeroColor == "string" && m.zeroColor.trim() ? m.zeroColor : void 0), C = t(() => st({
			cellColor: m.cellColor,
			cellValue: m.cellValue,
			columnId: m.columnId,
			columnLabel: m.columnLabel,
			data: m.data,
			domain: m.domain,
			excludeZeroFromQuantiles: S.value !== void 0,
			formatValue: m.formatValue,
			levelCount: x.value.length,
			quantiles: m.quantiles,
			rowDescription: m.rowDescription,
			rowId: m.rowId,
			rowLabel: m.rowLabel,
			rowValues: m.rowValues
		})), w = t(() => {
			let e = Math.max(m.cellMinWidth, 1), t = C.value.columns.length, n = Math.max(m.gap, 0), r = Math.max(m.rowLabelWidth, 1);
			return {
				"--cw-viz-heatmap-cell-height": `${Math.max(m.cellHeight, 1)}px`,
				"--cw-viz-heatmap-cell-min-width": `${e}px`,
				"--cw-viz-heatmap-column-count": t,
				"--cw-viz-heatmap-gap": `${n}px`,
				"--cw-viz-heatmap-grid-min-width": `${r + t * e + t * n}px`,
				"--cw-viz-heatmap-row-label-width": `${r}px`
			};
		}), T = t(() => C.value.error ? C.value.error : `${C.value.rows.length} rows across ${C.value.columns.length} columns.`), E = t(() => {
			if (!m.showTooltip || !b.value) return null;
			let e = C.value.rows[b.value.rowIndex], t = e?.cells[b.value.columnIndex];
			return !e || t?.value === void 0 ? null : {
				column: t.column.label,
				formattedValue: t.formattedValue,
				horizontalPosition: b.value.horizontalPosition,
				rowDescription: e.description,
				rowLabel: e.label,
				showBelow: b.value.showBelow,
				x: b.value.x,
				y: b.value.y
			};
		});
		function D(e, t, n) {
			if (!m.showTooltip) return;
			let r = v.value?.getBoundingClientRect(), i = n.currentTarget?.getBoundingClientRect();
			if (!r || !i) return;
			let a = i.left - r.left + i.width / 2, o = i.top - r.top + i.height / 2;
			b.value = {
				columnIndex: t,
				horizontalPosition: a < r.width * .25 ? "start" : a > r.width * .75 ? "end" : "center",
				rowIndex: e,
				showBelow: o < 96,
				x: a,
				y: o
			};
		}
		function O() {
			b.value = null;
		}
		function k(e) {
			return e.color ? { backgroundColor: e.color } : e.value === 0 && S.value ? { backgroundColor: S.value } : { backgroundColor: x.value[e.level] };
		}
		function A(e, t, n) {
			m.onItemClick && m.onItemClick({
				column: t.column.datum,
				columnId: t.column.id,
				columnIndex: t.column.index,
				columnLabel: t.column.label,
				event: n,
				formattedValue: t.formattedValue,
				item: t.datum,
				itemType: "cell",
				row: e.datum,
				rowDescription: e.description,
				rowId: e.id,
				rowIndex: e.index,
				rowLabel: e.label,
				value: t.value
			});
		}
		return (t, u) => (d(), i("div", {
			ref: "chart-root",
			class: "cw-viz-heatmap",
			role: "group",
			"aria-label": l.ariaLabel
		}, [
			a("p", lt, g(T.value), 1),
			C.value.error ? (d(), i("p", ut, g(C.value.error), 1)) : (d(), i("div", dt, [a("div", {
				class: "cw-viz-heatmap__grid",
				style: c(w.value),
				role: "grid"
			}, [(d(!0), i(e, null, p(C.value.rows, (t) => (d(), i("div", {
				key: t.id,
				class: "cw-viz-heatmap__row",
				role: "row"
			}, [a("div", ft, [a("strong", null, g(t.label), 1), t.description ? (d(), i("span", pt, g(t.description), 1)) : r("", !0)]), (d(!0), i(e, null, p(t.cells, (r) => (d(), i(e, { key: r.id }, [r.value === void 0 ? (d(), i("span", mt)) : (d(), n(h(l.showTooltip || l.onItemClick ? "button" : "span"), {
				key: 0,
				type: l.showTooltip || l.onItemClick ? "button" : void 0,
				class: s(["cw-viz-heatmap__cell", `cw-viz-heatmap__cell--level-${r.level}`]),
				style: c(k(r)),
				role: "gridcell",
				"aria-label": `${t.label}, ${r.column.label}: ${r.formattedValue}`,
				onPointerenter: (e) => D(t.index, r.column.index, e),
				onPointerleave: O,
				onFocus: (e) => D(t.index, r.column.index, e),
				onBlur: O,
				onKeydown: y(O, ["esc"]),
				onClick: (e) => A(t, r, e)
			}, null, 40, [
				"type",
				"class",
				"style",
				"aria-label",
				"onPointerenter",
				"onFocus",
				"onClick"
			]))], 64))), 128))]))), 128)), a("div", ht, [u[0] ||= a("span", { "aria-hidden": "true" }, null, -1), (d(!0), i(e, null, p(C.value.columns, (e) => (d(), i("span", {
				key: e.id,
				class: "cw-viz-heatmap__column-label",
				role: "columnheader"
			}, g(e.label), 1))), 128))])], 4)])),
			E.value ? (d(), i("div", {
				key: 2,
				class: s(["cw-viz-heatmap__tooltip", [`cw-viz-heatmap__tooltip--${E.value.horizontalPosition}`, { "cw-viz-heatmap__tooltip--below": E.value.showBelow }]]),
				style: c({
					left: `${E.value.x}px`,
					top: `${E.value.y}px`
				}),
				role: "tooltip"
			}, [a("p", gt, [o(g(E.value.rowLabel) + " ", 1), E.value.rowDescription ? (d(), i("span", _t, g(E.value.rowDescription), 1)) : r("", !0)]), a("div", vt, [a("span", null, g(E.value.column), 1), a("strong", null, g(E.value.formattedValue), 1)])], 6)) : r("", !0)
		], 8, ct));
	}
}), [["__scopeId", "data-v-9db61c65"]]);
//#endregion
//#region src/components/cartesian/line-layout.js
function bt(e) {
	let t = !1;
	return e.map((e) => {
		if (!e) return t = !1, "";
		let n = t ? "L" : "M";
		return t = !0, `${n} ${e.x} ${e.y}`;
	}).filter(Boolean).join(" ");
}
function xt(e, t, n) {
	let r = t % 2 == 1, i = e.y + 16, a = e.y - 16;
	return r && i <= n.bottom - 2 ? i : !r && a >= n.top + 2 || r ? a : i;
}
function St({ categoryLabel: e, data: t, formatValue: n, height: r, pointDescription: i, pointValue: a, seriesColor: o, seriesId: s, seriesLabel: c, seriesPointBorderColor: l, seriesPointColor: u, seriesValueColor: d, seriesValues: f, width: p, xInset: m, yDomain: h, yStepSize: g, yTickCount: _, yTicks: v }) {
	let y = Array.isArray(t?.categories) ? t.categories : [], b = Array.isArray(t?.series) ? t.series : [];
	if (!y.length || !b.length) return {
		categories: [],
		domain: [0, 1],
		error: "",
		plot: {},
		series: [],
		yTicks: []
	};
	let x = y.map((t, n) => ({
		datum: t,
		index: n,
		label: String(e(t, n) ?? n + 1)
	})), S = b.map((e, t) => {
		let n = s(e, t) ?? t, r = C(f, e, t), i = C(o, e, t) || D("line", n, t), a = C(l, e, t) || "var(--cw-viz-line-point-border-color, #ffffff)";
		return {
			color: i,
			datum: e,
			id: n,
			index: t,
			label: String(c(e, t) ?? n),
			pointBorderColor: a,
			pointColor: C(u, e, t) || i,
			rawPoints: Array.isArray(r) ? r : [],
			valueColor: C(d, e, t) || i
		};
	}), T = S.flatMap((e) => e.rawPoints.slice(0, x.length).flatMap((t, n) => {
		let r = k(a(t, n, e.datum));
		return r === void 0 ? [] : [r];
	})), E = ne({
		categoryCount: x.length,
		height: r,
		values: T,
		width: p,
		xInset: m,
		yDomain: h,
		yStepSize: g,
		yTickCount: _,
		yTicks: v
	});
	return x.forEach((e, t) => {
		e.x = E.xPositions[t], e.displayLabel = O(e.label, Math.max(E.xStep || E.plot.width, 1) - 12);
	}), S.forEach((e) => {
		e.points = x.map((t, r) => {
			let o = e.rawPoints[r], s = k(a(o, r, e.datum));
			if (s === void 0) return null;
			let c = typeof i == "function" ? i(o, r, e.datum) : void 0, l = {
				category: t,
				datum: o,
				description: c == null || c === "" ? void 0 : String(c),
				index: r,
				value: s,
				x: t.x,
				y: E.mapY(s)
			};
			return l.formattedValue = w(n, s, o, e.datum), l.labelY = xt(l, e.index, E.plot), l;
		}), e.path = bt(e.points);
	}), {
		categories: x,
		domain: E.domain,
		error: T.length ? "" : "Line chart data must include at least one numeric value.",
		plot: E.plot,
		series: S,
		yTicks: E.yTicks.map((e) => ({
			formattedValue: w(n, e.value),
			value: e.value,
			y: e.y
		}))
	};
}
//#endregion
//#region src/components/cartesian/LineChart.vue
var Ct = {
	ref: "chart-root",
	class: "cw-viz-line"
}, wt = ["viewBox", "aria-label"], Tt = {
	key: 0,
	class: "cw-viz-line__empty",
	x: "50%",
	y: "50%",
	"text-anchor": "middle"
}, Et = { key: 1 }, Dt = {
	class: "cw-viz-line__axes",
	"data-viz-layer": "axes"
}, Ot = [
	"x1",
	"x2",
	"y1",
	"y2"
], kt = [
	"x1",
	"x2",
	"y1",
	"y2"
], At = ["transform"], jt = ["x1", "x2"], Mt = ["x"], Nt = ["transform"], Pt = {
	class: "cw-viz-line__axis-label cw-viz-line__axis-label--x",
	x: "0",
	y: "30",
	"text-anchor": "middle"
}, Ft = {
	class: "cw-viz-line__series-layer",
	"data-viz-layer": "series"
}, It = ["data-series-id"], Lt = ["d", "stroke"], Rt = [
	"transform",
	"data-point-index",
	"tabindex",
	"role",
	"aria-label",
	"onClick",
	"onKeydown",
	"onPointerenter",
	"onFocus"
], zt = [
	"r",
	"fill",
	"stroke"
], Bt = ["r", "fill"], Vt = ["y", "fill"], Ht = { class: "cw-viz-line__tooltip-title" }, Ut = { class: "cw-viz-line__tooltip-list" }, Wt = { class: "cw-viz-line__tooltip-label" }, Gt = { class: "cw-viz-line__tooltip-value" }, Kt = {
	key: 0,
	class: "cw-viz-line__tooltip-description"
}, qt = /*#__PURE__*/ B(/* @__PURE__ */ Object.assign({ name: "LineChart" }, {
	__name: "LineChart",
	props: {
		ariaLabel: {
			type: String,
			default: "Line chart"
		},
		categoryLabel: {
			type: Function,
			default: (e) => e?.label ?? e
		},
		data: {
			type: Object,
			required: !0
		},
		formatValue: {
			type: [Function, String],
			default: () => (e) => Number(e).toLocaleString()
		},
		height: {
			type: Number,
			default: 360
		},
		onItemClick: {
			type: Function,
			default: void 0
		},
		pointDescription: {
			type: Function,
			default: (e) => e?.description
		},
		pointRadius: {
			type: Number,
			default: 5
		},
		pointValue: {
			type: Function,
			default: (e) => typeof e == "number" ? e : e?.value ?? e?.y
		},
		seriesColor: {
			type: [Function, String],
			default: () => (e) => e.color
		},
		seriesId: {
			type: Function,
			default: (e, t) => e.id ?? t
		},
		seriesLabel: {
			type: Function,
			default: (e, t) => e.label ?? e.id ?? `Series ${t + 1}`
		},
		seriesPointBorderColor: {
			type: [Function, String],
			default: () => (e) => e.pointBorderColor
		},
		seriesPointColor: {
			type: [Function, String],
			default: () => (e) => e.pointColor
		},
		seriesValueColor: {
			type: [Function, String],
			default: () => (e) => e.valueColor ?? e.labelColor
		},
		seriesValues: {
			type: Function,
			default: (e) => e.data ?? e.values ?? []
		},
		showValues: {
			type: Boolean,
			default: !0
		},
		showTooltip: {
			type: Boolean,
			default: !0
		},
		width: {
			type: Number,
			default: 960
		},
		xInset: {
			type: Number,
			default: void 0
		},
		yDomain: {
			type: Array,
			default: void 0
		},
		yStepSize: {
			type: [Number, Function],
			default: void 0,
			validator: (e) => typeof e == "function" || Number.isFinite(e) && e > 0
		},
		yTickCount: {
			type: Number,
			default: 5
		},
		yTicks: {
			type: Array,
			default: void 0
		}
	},
	setup(n) {
		let o = n, m = _("chart-root"), h = f(0), v = f(null), y, b, x = t(() => Math.max(Math.round(h.value || o.width), 280)), S = t(() => St({
			categoryLabel: o.categoryLabel,
			data: o.data,
			formatValue: o.formatValue,
			height: o.height,
			pointDescription: o.pointDescription,
			pointValue: o.pointValue,
			seriesColor: o.seriesColor,
			seriesId: o.seriesId,
			seriesLabel: o.seriesLabel,
			seriesPointBorderColor: o.seriesPointBorderColor,
			seriesPointColor: o.seriesPointColor,
			seriesValueColor: o.seriesValueColor,
			seriesValues: o.seriesValues,
			width: x.value,
			xInset: o.xInset,
			yDomain: o.yDomain,
			yStepSize: o.yStepSize,
			yTickCount: o.yTickCount,
			yTicks: o.yTicks
		})), C = t(() => S.value.error ? S.value.error : `${S.value.series.length} series across ${S.value.categories.length} categories.`), w = t(() => {
			if (!o.showTooltip || !v.value) return null;
			let e = S.value.series[v.value.seriesIndex]?.points[v.value.pointIndex];
			return e ? {
				category: e.category.label,
				horizontalPosition: e.x < x.value * .25 ? "start" : e.x > x.value * .75 ? "end" : "center",
				rows: S.value.series.flatMap((e) => {
					let t = e.points[v.value.pointIndex];
					return t ? [{
						color: e.pointColor,
						description: t.description,
						formattedValue: t.formattedValue,
						id: e.id,
						isActive: e.index === v.value.seriesIndex,
						label: e.label
					}] : [];
				}),
				showBelow: e.y < o.height * .3,
				x: v.value.x,
				y: v.value.y
			} : null;
		});
		function E(e) {
			Number.isFinite(e) && e > 0 && (h.value = e, v.value = null);
		}
		function D(e, t, n) {
			if (!o.showTooltip) return;
			let r = m.value?.getBoundingClientRect(), i = n.currentTarget?.getScreenCTM?.(), a = S.value.series[e]?.points[t];
			!r || !a || (v.value = {
				pointIndex: t,
				seriesIndex: e,
				x: i ? i.e - r.left : a.x / x.value * r.width,
				y: i ? i.f - r.top : a.y / o.height * r.height
			});
		}
		function O() {
			v.value = null;
		}
		function k(e, t, n) {
			if (!o.onItemClick) return;
			let r = S.value.series[e], i = r?.points[t];
			!r || !i || o.onItemClick(T(r, i, n));
		}
		function A(e, t, n) {
			!o.onItemClick || !["Enter", " "].includes(n.key) || (n.preventDefault(), k(e, t, n));
		}
		function j(e) {
			if (typeof requestAnimationFrame > "u") {
				E(e);
				return;
			}
			b && cancelAnimationFrame(b), b = requestAnimationFrame(() => {
				b = void 0, E(e);
			});
		}
		return u(() => {
			E(m.value?.getBoundingClientRect().width), !(typeof ResizeObserver > "u" || !m.value) && (y = new ResizeObserver((e) => {
				j(e[0]?.contentRect.width);
			}), y.observe(m.value));
		}), l(() => {
			y?.disconnect(), b && cancelAnimationFrame(b);
		}), (t, o) => (d(), i("div", Ct, [(d(), i("svg", {
			class: "cw-viz-line__svg",
			viewBox: `0 0 ${x.value} ${n.height}`,
			role: "img",
			"aria-label": n.ariaLabel,
			preserveAspectRatio: "xMidYMid meet"
		}, [a("desc", null, g(C.value), 1), S.value.error || !S.value.series.length ? (d(), i("text", Tt, g(S.value.error || "No line data to display."), 1)) : (d(), i("g", Et, [a("g", Dt, [
			a("line", {
				class: "cw-viz-line__axis",
				x1: S.value.plot.left,
				x2: S.value.plot.left,
				y1: S.value.plot.top,
				y2: S.value.plot.bottom
			}, null, 8, Ot),
			a("line", {
				class: "cw-viz-line__axis",
				x1: S.value.plot.left,
				x2: S.value.plot.right,
				y1: S.value.plot.bottom,
				y2: S.value.plot.bottom
			}, null, 8, kt),
			(d(!0), i(e, null, p(S.value.yTicks, (e) => (d(), i("g", {
				key: e.value,
				class: "cw-viz-line__y-tick",
				transform: `translate(0 ${e.y})`
			}, [a("line", {
				class: "cw-viz-line__tick-mark",
				x1: S.value.plot.left - 9,
				x2: S.value.plot.left,
				y1: "0",
				y2: "0"
			}, null, 8, jt), a("text", {
				class: "cw-viz-line__axis-label cw-viz-line__axis-label--y",
				x: S.value.plot.left - 14,
				y: "0",
				"dominant-baseline": "central",
				"text-anchor": "end"
			}, g(e.formattedValue), 9, Mt)], 8, At))), 128)),
			(d(!0), i(e, null, p(S.value.categories, (e) => (d(), i("g", {
				key: e.index,
				class: "cw-viz-line__x-tick",
				transform: `translate(${e.x} ${S.value.plot.bottom})`
			}, [o[0] ||= a("line", {
				class: "cw-viz-line__tick-mark",
				x1: "0",
				x2: "0",
				y1: "0",
				y2: "10"
			}, null, -1), a("text", Pt, g(e.displayLabel), 1)], 8, Nt))), 128))
		]), a("g", Ft, [(d(!0), i(e, null, p(S.value.series, (t) => (d(), i("g", {
			key: t.id,
			class: "cw-viz-line__series",
			"data-series-id": t.id
		}, [a("path", {
			class: "cw-viz-line__path",
			d: t.path,
			stroke: t.color
		}, null, 8, Lt), (d(!0), i(e, null, p(t.points.filter(Boolean), (e) => (d(), i("g", {
			key: e.index,
			class: s(["cw-viz-line__point-group", { "cw-viz-line__point-group--clickable": n.onItemClick }]),
			transform: `translate(${e.x} ${e.y})`,
			"data-point-index": e.index,
			tabindex: n.showTooltip || n.onItemClick ? 0 : void 0,
			role: n.onItemClick ? "button" : void 0,
			"aria-label": `${t.label}, ${e.category.label}: ${e.formattedValue}${e.description ? `. ${e.description}` : ""}`,
			onClick: (n) => k(t.index, e.index, n),
			onKeydown: (n) => A(t.index, e.index, n),
			onPointerenter: (n) => D(t.index, e.index, n),
			onPointerleave: O,
			onFocus: (n) => D(t.index, e.index, n),
			onBlur: O
		}, [
			a("circle", {
				class: "cw-viz-line__point-background",
				cx: "0",
				cy: "0",
				r: n.pointRadius,
				fill: t.pointBorderColor,
				stroke: t.pointBorderColor,
				"aria-hidden": "true"
			}, null, 8, zt),
			a("circle", {
				class: "cw-viz-line__point",
				cx: "0",
				cy: "0",
				r: n.pointRadius * .8,
				fill: t.pointColor
			}, null, 8, Bt),
			n.showValues ? (d(), i("text", {
				key: 0,
				class: "cw-viz-line__value",
				x: "0",
				y: e.labelY - e.y,
				fill: t.valueColor,
				"dominant-baseline": "central",
				"text-anchor": "middle"
			}, g(e.formattedValue), 9, Vt)) : r("", !0)
		], 42, Rt))), 128))], 8, It))), 128))])]))], 8, wt)), w.value ? (d(), i("div", {
			key: 0,
			class: s(["cw-viz-line__tooltip", [`cw-viz-line__tooltip--${w.value.horizontalPosition}`, { "cw-viz-line__tooltip--below": w.value.showBelow }]]),
			style: c({
				left: `${w.value.x}px`,
				top: `${w.value.y}px`
			}),
			role: "tooltip"
		}, [a("p", Ht, g(w.value.category), 1), a("div", Ut, [(d(!0), i(e, null, p(w.value.rows, (e) => (d(), i("div", {
			key: e.id,
			class: s(["cw-viz-line__tooltip-row", { "cw-viz-line__tooltip-row--active": e.isActive }])
		}, [
			a("span", {
				class: "cw-viz-line__tooltip-dot",
				style: c({ backgroundColor: e.color })
			}, null, 4),
			a("span", Wt, g(e.label), 1),
			a("strong", Gt, g(e.formattedValue), 1),
			e.description ? (d(), i("span", Kt, g(e.description), 1)) : r("", !0)
		], 2))), 128))])], 6)) : r("", !0)], 512));
	}
}), [["__scopeId", "data-v-3acfb47d"]]);
//#endregion
//#region src/components/percentage/percentage-layout.js
function Jt(e) {
	return Ae({
		...e,
		chartName: "Percentage chart",
		colorNamespace: "percentage"
	});
}
//#endregion
//#region src/components/percentage/PercentageChart.vue
var Yt = ["aria-label"], Xt = { class: "cw-viz-percentage__description" }, Zt = {
	key: 0,
	class: "cw-viz-percentage__empty"
}, Qt = { class: "cw-viz-percentage__bar" }, $t = { class: "cw-viz-percentage__tooltip-main" }, en = {
	key: 0,
	class: "cw-viz-percentage__tooltip-description"
}, tn = {
	key: 1,
	class: "cw-viz-percentage__legend"
}, nn = /*#__PURE__*/ B(/* @__PURE__ */ Object.assign({ name: "PercentageChart" }, {
	__name: "PercentageChart",
	props: {
		ariaLabel: {
			type: String,
			default: "Percentage chart"
		},
		barGap: {
			type: Number,
			default: 2
		},
		barHeight: {
			type: Number,
			default: 24
		},
		barRadius: {
			type: Number,
			default: 4
		},
		data: {
			type: Object,
			required: !0
		},
		formatPercentage: {
			type: [Function, String],
			default: "%"
		},
		formatValue: {
			type: [Function, String],
			default: () => (e) => Number(e).toLocaleString()
		},
		onItemClick: {
			type: Function,
			default: void 0
		},
		remainderColor: {
			type: String,
			default: "var(--cw-viz-percentage-remainder-color, #f0f0f3)"
		},
		remainderLabel: {
			type: String,
			default: "Unused"
		},
		segmentColor: {
			type: [Function, String],
			default: () => (e) => e?.color
		},
		segmentId: {
			type: Function,
			default: (e, t) => e?.id ?? t
		},
		segmentLabel: {
			type: Function,
			default: (e, t) => e?.label ?? e?.id ?? `Segment ${t + 1}`
		},
		segmentValue: {
			type: Function,
			default: (e) => typeof e == "number" ? e : e?.value ?? e?.count
		},
		showLegend: {
			type: Boolean,
			default: !0
		},
		showTooltip: {
			type: Boolean,
			default: !0
		}
	},
	setup(o) {
		let l = o, u = _("chart-root"), b = f(null), x = t(() => Jt({
			data: l.data,
			formatPercentage: l.formatPercentage,
			formatValue: l.formatValue,
			remainderColor: l.remainderColor,
			remainderLabel: l.remainderLabel,
			segmentColor: l.segmentColor,
			segmentId: l.segmentId,
			segmentLabel: l.segmentLabel,
			segmentValue: l.segmentValue
		})), S = t(() => ({
			"--cw-viz-percentage-bar-gap": `${Math.max(l.barGap, 0)}px`,
			"--cw-viz-percentage-bar-height": `${Math.max(l.barHeight, 1)}px`,
			"--cw-viz-percentage-bar-radius": `${Math.max(l.barRadius, 0)}px`
		})), C = t(() => x.value.segments.filter((e) => e.percentage > 0)), w = t(() => l.showTooltip ? b.value : null), T = t(() => x.value.error ? x.value.error : x.value.segments.map((e) => `${e.label}: ${e.tooltipValue}${e.description ? `. ${e.description}` : ""}`).join(", "));
		function E(e, t) {
			if (!l.showTooltip) return;
			let n = u.value?.getBoundingClientRect(), r = t.currentTarget?.getBoundingClientRect();
			if (!n || !r) return;
			let i = r.left - n.left + r.width / 2;
			b.value = {
				horizontalPosition: i < n.width * .25 ? "start" : i > n.width * .75 ? "end" : "center",
				description: e.description,
				label: e.label,
				segmentIndex: e.index,
				value: e.tooltipValue,
				x: i,
				y: r.top - n.top
			};
		}
		function D() {
			b.value = null;
		}
		v(x, D);
		function O(e, t) {
			l.onItemClick && l.onItemClick({
				event: t,
				formattedPercentage: e.formattedPercentage,
				formattedValue: e.formattedValue,
				description: e.description,
				id: e.id,
				index: e.index,
				isRemainder: e.isRemainder,
				item: e.datum,
				itemType: e.isRemainder ? "remainder" : "segment",
				label: e.label,
				percentage: e.percentage,
				value: e.value
			});
		}
		return (t, l) => (d(), i("div", {
			ref: "chart-root",
			class: "cw-viz-percentage",
			style: c(S.value),
			role: "group",
			"aria-label": o.ariaLabel
		}, [a("p", Xt, g(T.value), 1), x.value.error ? (d(), i("p", Zt, g(x.value.error), 1)) : (d(), i(e, { key: 1 }, [
			a("div", Qt, [(d(!0), i(e, null, p(C.value, (e) => (d(), n(h(o.showTooltip || o.onItemClick ? "button" : "span"), {
				key: e.key,
				type: o.showTooltip || o.onItemClick ? "button" : void 0,
				class: s(["cw-viz-percentage__segment", { "cw-viz-percentage__segment--remainder": e.isRemainder }]),
				style: c({
					"--cw-viz-percentage-segment-color": e.color,
					"--cw-viz-percentage-segment-size": e.percentage
				}),
				"aria-label": `${e.label}: ${e.tooltipValue}${e.description ? `. ${e.description}` : ""}`,
				onPointerenter: (t) => E(e, t),
				onPointerleave: D,
				onFocus: (t) => E(e, t),
				onBlur: D,
				onKeydown: y(D, ["esc"]),
				onClick: (t) => O(e, t)
			}, null, 40, [
				"type",
				"class",
				"style",
				"aria-label",
				"onPointerenter",
				"onFocus",
				"onClick"
			]))), 128))]),
			w.value ? (d(), i("div", {
				key: 0,
				class: s(["cw-viz-percentage__tooltip", `cw-viz-percentage__tooltip--${w.value.horizontalPosition}`]),
				style: c({
					left: `${w.value.x}px`,
					top: `${w.value.y}px`
				}),
				role: "tooltip"
			}, [a("div", $t, [a("span", null, g(w.value.label), 1), a("strong", null, g(w.value.value), 1)]), w.value.description ? (d(), i("span", en, g(w.value.description), 1)) : r("", !0)], 6)) : r("", !0),
			o.showLegend ? (d(), i("ul", tn, [(d(!0), i(e, null, p(x.value.segments, (e) => (d(), i("li", {
				key: e.key,
				class: s({ "cw-viz-percentage__legend-item--remainder": e.isRemainder })
			}, [m(t.$slots, "legend-item", {
				color: e.color,
				description: e.description,
				formattedPercentage: e.formattedPercentage,
				formattedValue: e.formattedValue,
				id: e.id,
				index: e.index,
				isRemainder: e.isRemainder,
				item: e.datum,
				label: e.label,
				percentage: e.percentage,
				value: e.value
			}, () => [
				a("span", {
					class: s(["cw-viz-percentage__swatch", { "cw-viz-percentage__swatch--remainder": e.isRemainder }]),
					style: c({ "--cw-viz-percentage-segment-color": e.color }),
					"aria-hidden": "true"
				}, null, 6),
				a("span", null, g(e.label), 1),
				a("strong", null, g(e.formattedPercentage), 1)
			], !0)], 2))), 128))])) : r("", !0)
		], 64))], 12, Yt));
	}
}), [["__scopeId", "data-v-16f45f3a"]]), J = 2, rn = 38, an = 16, Y = 16, X = 26, Z = 8, Q = 8, $ = 7;
function on(e, t = 0) {
	let n = Number(e);
	return Number.isFinite(n) ? n : t;
}
function sn(e, t, n) {
	return typeof e == "function" ? e(t, n) : e;
}
function cn(e) {
	return String(e).toLowerCase().replace(/[^a-z0-9_-]+/g, "-").replace(/^-+|-+$/g, "");
}
function ln(e) {
	let t = cn(e), n = t ? `--cw-viz-sankey-node-${t}-color` : "";
	return n ? `var(${n}, var(--cw-viz-sankey-node-color, #4747c2))` : "var(--cw-viz-sankey-node-color, #4747c2)";
}
function un(e, t, n, r, i) {
	if (r.has(e)) return r.get(e);
	if (n.has(e)) return n.get(e);
	if (e && typeof e == "object") {
		let t = i(e);
		if (n.has(t)) return n.get(t);
	}
	if (Number.isInteger(e) && e >= 0 && e < t.length) return t[e];
}
function dn(e) {
	let t = new Map(e.map((e) => [e, e.targetLinks.length])), n = e.filter((e) => t.get(e) === 0), r = 0, i = 0;
	for (; r < n.length;) {
		let e = n[r];
		r += 1, i += 1, e.sourceLinks.forEach((r) => {
			r.target.layer = Math.max(r.target.layer, e.layer + 1);
			let i = t.get(r.target) - 1;
			t.set(r.target, i), i === 0 && n.push(r.target);
		});
	}
	return i === e.length;
}
function fn(e) {
	let t = e.source.x + e.source.width, n = e.target.x, r = t + (n - t) / 2, i = e.sourceY + e.width, a = e.targetY + e.width;
	return [
		`M ${t} ${e.sourceY}`,
		`C ${r} ${e.sourceY} ${r} ${e.targetY} ${n} ${e.targetY}`,
		`L ${n} ${a}`,
		`C ${r} ${a} ${r} ${i} ${t} ${i}`,
		"Z"
	].join(" ");
}
function pn(e, t) {
	let n = Math.max(Math.floor(t / $), 1);
	return e.length <= n ? e : n <= 1 ? "…" : `${e.slice(0, n - 1).trimEnd()}…`;
}
function mn(e, t, n, r, i) {
	let a = String(i(e.displayValue, e.datum)), o = Math.max(a.length * $, $), s = e.layer === t, c = s ? e.x + e.width + Z : Math.max(4, e.x - Z), l = Math.max(42, Math.min(220, s ? r - c - 4 : n - c - Z)), u = Math.max(l - o - 16 - 16, $), d = pn(e.label, u), f = d.length * $ + o + 16 + 16, p = Math.min(f, l), m = s ? Math.max(2, e.y + e.height / 2 - X / 2) : Math.max(2, e.y - X);
	return {
		countX: p - Q,
		height: X,
		isTerminal: s,
		labelX: Q,
		separatorX: p - o - Q - Z,
		text: d,
		value: a,
		width: p,
		x: c,
		y: m
	};
}
function hn({ data: e, formatValue: t, height: n, linkColor: r, linkValue: i, nodeColor: a, nodeId: o, nodeLabel: s, nodePadding: c, nodeValue: l, nodeWidth: u, width: d }) {
	let f = Array.isArray(e?.nodes) ? e.nodes : [], p = Array.isArray(e?.links) ? e.links : [];
	if (!f.length) return {
		error: "",
		links: [],
		nodes: []
	};
	let m = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Set(), _ = f.map((e, t) => {
		let n = o(e, t) ?? t, r = Math.max(on(l(e, t)), 0), i = {
			color: sn(a, e, t) || ln(n),
			datum: e,
			displayValue: r,
			id: n,
			index: t,
			label: String(s(e, t) ?? n),
			layer: 0,
			sourceLinks: [],
			targetLinks: []
		};
		return m.has(n) && g.add(n), m.set(n, i), h.set(e, i), i;
	});
	if (g.size) return {
		error: `Sankey node ids must be unique: ${[...g].join(", ")}`,
		links: [],
		nodes: []
	};
	let v = [], y = p.flatMap((e, t) => {
		let n = un(e.source, _, m, h, o), a = un(e.target, _, m, h, o), s = i(e, t), c = s == null ? 1 : Number(s);
		if (!n || !a) return v.push(`link ${t} references an unknown node`), [];
		if (n === a) return v.push(`link ${t} is a self-reference`), [];
		if (!Number.isFinite(c) || c <= 0) return v.push(`link ${t} must have a positive numeric value`), [];
		let l = {
			color: sn(r, e, t),
			datum: e,
			index: t,
			source: n,
			target: a,
			value: c
		};
		return n.sourceLinks.push(l), a.targetLinks.push(l), [l];
	});
	if (v.length) return {
		error: `Invalid Sankey data: ${v.join("; ")}.`,
		links: [],
		nodes: []
	};
	if (!dn(_)) return {
		error: "Sankey data must be an acyclic directed graph.",
		links: [],
		nodes: []
	};
	let b = Math.max(..._.map((e) => e.layer), 0), x = Array.from({ length: b + 1 }, () => []);
	_.forEach((e) => x[e.layer].push(e)), _.forEach((e) => {
		let t = e.targetLinks.reduce((e, t) => e + t.value, 0), n = e.sourceLinks.reduce((e, t) => e + t.value, 0);
		e.value = Math.max(e.displayValue, t, n), e.displayValue === 0 && e.value > 0 && (e.displayValue = e.value);
	});
	let S = Math.min(220, Math.max(104, d * .28)), C = Math.max(Y + u, d - S), w = b ? (C - Y - u) / b : 0, T = Math.max(n - rn - an, 1), E = x.map((e) => {
		if (e.length <= 1) return 0;
		let t = (T - e.length * J) / (e.length - 1);
		return Math.max(Math.min(c, t), 0);
	}), D = Math.min(...x.map((e, t) => {
		let n = e.reduce((e, t) => e + t.value, 0), r = Math.max(e.length - 1, 0) * E[t], i = e.filter((e) => e.value === 0).length * J;
		return n > 0 ? Math.max(T - r - i, 1) / n : 1;
	}));
	return x.forEach((e, t) => {
		let n = e.map((e) => Math.max(e.value * D, J)), r = n.reduce((e, t) => e + t, 0) + Math.max(e.length - 1, 0) * E[t], i = rn + Math.max((T - r) / 2, 0);
		e.forEach((e, r) => {
			e.height = n[r], e.width = u, e.x = Y + w * t, e.y = i, i += e.height + E[t];
		});
	}), _.forEach((e) => {
		e.sourceLinks.sort((e, t) => e.target.y - t.target.y), e.targetLinks.sort((e, t) => e.source.y - t.source.y);
		let t = e.sourceLinks.reduce((e, t) => e + t.value * D, 0), n = e.targetLinks.reduce((e, t) => e + t.value * D, 0), r = e.y + Math.max((e.height - t) / 2, 0), i = e.y + Math.max((e.height - n) / 2, 0);
		e.sourceLinks.forEach((e) => {
			e.sourceY = r, r += e.value * D;
		}), e.targetLinks.forEach((e) => {
			e.targetY = i, i += e.value * D;
		});
	}), y.forEach((e) => {
		e.width = e.value * D, e.color = e.color || e.target.color, e.path = fn(e);
	}), _.forEach((e) => {
		let n = e.layer < b ? x[e.layer + 1][0].x : d;
		e.labelLayout = mn(e, b, n, d, t);
	}), {
		error: "",
		links: y,
		nodes: _
	};
}
//#endregion
//#region src/components/sankey/SankeyChart.vue
var gn = {
	ref: "chart-root",
	class: "cw-viz-sankey"
}, _n = ["viewBox", "aria-label"], vn = {
	key: 0,
	class: "cw-viz-sankey__empty",
	x: "50%",
	y: "50%",
	"text-anchor": "middle"
}, yn = { key: 1 }, bn = {
	class: "cw-viz-sankey__links",
	"data-viz-layer": "links"
}, xn = [
	"tabindex",
	"role",
	"aria-label",
	"onClick",
	"onKeydown"
], Sn = [
	"d",
	"fill",
	"data-source",
	"data-target"
], Cn = ["d"], wn = {
	class: "cw-viz-sankey__nodes",
	"data-viz-layer": "nodes"
}, Tn = [
	"data-node-id",
	"tabindex",
	"role",
	"aria-label",
	"onClick",
	"onKeydown"
], En = [
	"x",
	"y",
	"width",
	"height",
	"fill"
], Dn = ["transform"], On = ["width", "height"], kn = ["x", "y"], An = [
	"x1",
	"x2",
	"y2"
], jn = ["x", "y"], Mn = /*#__PURE__*/ B(/* @__PURE__ */ Object.assign({ name: "SankeyChart" }, {
	__name: "SankeyChart",
	props: {
		ariaLabel: {
			type: String,
			default: "Sankey diagram"
		},
		data: {
			type: Object,
			required: !0
		},
		formatValue: {
			type: Function,
			default: (e) => Number(e).toLocaleString()
		},
		height: {
			type: Number,
			default: 340
		},
		linkColor: {
			type: [Function, String],
			default: () => (e) => e.color
		},
		linkValue: {
			type: Function,
			default: (e) => e.value ?? 1
		},
		nodeColor: {
			type: [Function, String],
			default: () => (e) => e.color
		},
		nodeId: {
			type: Function,
			default: (e) => e.id
		},
		nodeLabel: {
			type: Function,
			default: (e) => e.label ?? e.id
		},
		nodePadding: {
			type: Number,
			default: 28
		},
		nodeValue: {
			type: Function,
			default: (e) => e.count ?? e.value ?? 0
		},
		nodeWidth: {
			type: Number,
			default: 10
		},
		onItemClick: {
			type: Function,
			default: void 0
		},
		showLabelBackground: {
			type: Boolean,
			default: !0
		},
		width: {
			type: Number,
			default: 960
		}
	},
	setup(n) {
		let o = n, c = _("chart-root"), m = f(0), h, v, y = t(() => Math.max(Math.round(m.value || o.width), 320)), b = t(() => hn({
			data: o.data,
			formatValue: o.formatValue,
			height: o.height,
			linkColor: o.linkColor,
			linkValue: o.linkValue,
			nodeColor: o.nodeColor,
			nodeId: o.nodeId,
			nodeLabel: o.nodeLabel,
			nodePadding: o.nodePadding,
			nodeValue: o.nodeValue,
			nodeWidth: o.nodeWidth,
			width: y.value
		})), x = t(() => b.value.error ? b.value.error : `${b.value.nodes.length} nodes connected by ${b.value.links.length} flows.`);
		function S(e, t, n) {
			return e === "node" ? {
				event: n,
				formattedValue: String(o.formatValue(t.displayValue, t.datum)),
				id: t.id,
				index: t.index,
				item: t.datum,
				itemType: e,
				label: t.label,
				value: t.displayValue
			} : {
				event: n,
				formattedValue: String(o.formatValue(t.value, t.datum)),
				index: t.index,
				item: t.datum,
				itemType: e,
				source: t.source.datum,
				sourceId: t.source.id,
				sourceLabel: t.source.label,
				target: t.target.datum,
				targetId: t.target.id,
				targetLabel: t.target.label,
				value: t.value
			};
		}
		function C(e, t, n) {
			o.onItemClick && o.onItemClick(S(e, t, n));
		}
		function w(e, t, n) {
			!o.onItemClick || !["Enter", " "].includes(n.key) || (n.preventDefault(), C(e, t, n));
		}
		function T(e) {
			Number.isFinite(e) && e > 0 && (m.value = e);
		}
		function E(e) {
			if (typeof requestAnimationFrame > "u") {
				T(e);
				return;
			}
			v && cancelAnimationFrame(v), v = requestAnimationFrame(() => {
				v = void 0, T(e);
			});
		}
		return u(() => {
			T(c.value?.getBoundingClientRect().width), !(typeof ResizeObserver > "u" || !c.value) && (h = new ResizeObserver((e) => {
				E(e[0]?.contentRect.width);
			}), h.observe(c.value));
		}), l(() => {
			h?.disconnect(), v && cancelAnimationFrame(v);
		}), (t, o) => (d(), i("div", gn, [(d(), i("svg", {
			class: "cw-viz-sankey__svg",
			viewBox: `0 0 ${y.value} ${n.height}`,
			role: "img",
			"aria-label": n.ariaLabel,
			preserveAspectRatio: "xMidYMid meet"
		}, [
			a("title", null, g(n.ariaLabel), 1),
			a("desc", null, g(x.value), 1),
			b.value.error || !b.value.nodes.length ? (d(), i("text", vn, g(b.value.error || "No Sankey data to display."), 1)) : (d(), i("g", yn, [a("g", bn, [(d(!0), i(e, null, p(b.value.links, (e) => (d(), i("g", {
				key: e.index,
				class: s(["cw-viz-sankey__link-group", { "cw-viz-sankey__link-group--clickable": n.onItemClick }]),
				tabindex: n.onItemClick ? 0 : void 0,
				role: n.onItemClick ? "button" : void 0,
				"aria-label": `${e.source.label} to ${e.target.label}: ${n.formatValue(e.value, e.datum)}`,
				onClick: (t) => C("link", e, t),
				onKeydown: (t) => w("link", e, t)
			}, [
				a("path", {
					class: "cw-viz-sankey__link",
					d: e.path,
					fill: e.color,
					"data-source": e.source.id,
					"data-target": e.target.id
				}, null, 8, Sn),
				a("path", {
					class: "cw-viz-sankey__link-hit-area",
					d: e.path,
					"aria-hidden": "true"
				}, null, 8, Cn),
				a("title", null, g(e.source.label) + " to " + g(e.target.label) + ": " + g(n.formatValue(e.value, e.datum)), 1)
			], 42, xn))), 128))]), a("g", wn, [(d(!0), i(e, null, p(b.value.nodes, (e) => (d(), i("g", {
				key: e.id,
				class: s(["cw-viz-sankey__node-group", { "cw-viz-sankey__node-group--clickable": n.onItemClick }]),
				"data-node-id": e.id,
				tabindex: n.onItemClick ? 0 : void 0,
				role: n.onItemClick ? "button" : void 0,
				"aria-label": `${e.label}: ${n.formatValue(e.displayValue, e.datum)}`,
				onClick: (t) => C("node", e, t),
				onKeydown: (t) => w("node", e, t)
			}, [a("rect", {
				class: "cw-viz-sankey__node",
				x: e.x,
				y: e.y,
				width: e.width,
				height: e.height,
				fill: e.color,
				rx: "2"
			}, [a("title", null, g(e.label) + ": " + g(n.formatValue(e.displayValue, e.datum)), 1)], 8, En), a("g", {
				class: "cw-viz-sankey__label",
				transform: `translate(${e.labelLayout.x} ${e.labelLayout.y})`
			}, [
				n.showLabelBackground ? (d(), i("rect", {
					key: 0,
					class: s(["cw-viz-sankey__label-background", { "cw-viz-sankey__label-background--terminal": e.labelLayout.isTerminal }]),
					width: e.labelLayout.width,
					height: e.labelLayout.height,
					rx: "6"
				}, null, 10, On)) : r("", !0),
				a("text", {
					class: "cw-viz-sankey__label-text",
					x: e.labelLayout.labelX,
					y: e.labelLayout.height / 2,
					"dominant-baseline": "central"
				}, g(e.labelLayout.text), 9, kn),
				a("line", {
					class: "cw-viz-sankey__label-divider",
					x1: e.labelLayout.separatorX,
					x2: e.labelLayout.separatorX,
					y1: "6",
					y2: e.labelLayout.height - 6
				}, null, 8, An),
				a("text", {
					class: "cw-viz-sankey__label-value",
					x: e.labelLayout.countX,
					y: e.labelLayout.height / 2,
					"dominant-baseline": "central",
					"text-anchor": "end"
				}, g(e.labelLayout.value), 9, jn),
				a("title", null, g(e.label) + ": " + g(e.labelLayout.value), 1)
			], 8, Dn)], 42, Tn))), 128))])]))
		], 8, _n))], 512));
	}
}), [["__scopeId", "data-v-b808b7b9"]]);
//#endregion
export { De as BarChart, $e as DonutChart, yt as HeatmapChart, qt as LineChart, nn as PercentageChart, Mn as SankeyChart };
